<template>
  <div class="sso-complete">
    <p>Signing you in…</p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import AuthenticationService from '@/services/authentication/AuthenticationService'
import store from '@/store'

onMounted(async () => {
  const params = new URLSearchParams(window.location.search)
  const token = params.get('token')

  if (!token) {
    window.location.href = '/login'
    return
  }

  // Store token using your existing auth service
  AuthenticationService.setToken(token)

  try {
    // Load user into Vuex store
    await store.dispatch('auth/fetchUser')

    // Redirect to default authenticated page
    const router = useRouter()

    await router.replace('/my-profile')
  } catch (error) {
    console.error('SSO login failed:', error)
    AuthenticationService.clearToken()
    window.location.href = '/login'
  }
})
</script>
